<template>
  <div>
    <v-dialog
      :value="visible"
      style="z-index: 1000"
      persistent
      max-width="40rem"
      width="48vw"
    >
      <v-card>
        <v-card-text v-html="body" class="body" />
        <v-checkbox
          :key="index"
          v-for="(_, index) in [0]"
          @change="value => (isChecked = value)"
          :input-value="isChecked"
          label="次回からこのメッセージを表示しない"
          class="checkbox checkBoxStyle"
          hide-details
          messages="none"
        />
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <AppButtonOk @click="ok" color="primary">
            閉じる
          </AppButtonOk>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <GlobalEvents @keydown.enter.shift="ok" />
  </div>
</template>

<script>
import GlobalEvents from 'vue-global-events'

export default {
  name: 'ConfirmModal',
  components: { GlobalEvents },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
    }
  },
  computed: {
    body() {
      return `広告ブロッカーツールをご利用の場合、管理画面が正しく動作しません。<br>広告ブロッカーツールをOFFにしてから、ご利用ください。`
    },
  },
  methods: {
    ok() {
      const isChecked = (() => {
        if (this.isChecked) return 'on'
        return 'off'
      })()
      // GAへeventを送信
      this.$sendEventToGA('buttonClick', {
        buttonName: 'adBlockerModalCloseButton',
        isChecked: isChecked,
      })
      this.$emit('close', this.isChecked)
    },
  },
}
</script>

<style scoped>
.body {
  font-size: 1.2rem;
  white-space: pre-line;
  word-wrap: break-word;
}
.checkBoxStyle {
  margin-top: 0;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
</style>
